<template>
  <div class="page">
    <h2>Модули</h2>
    <div class="modules">
      <div class="module">
        <div class="icon">
          <OrganizationIcon />
        </div>
        <div class="content">
          <div class="title">Модуль "Базовый"</div>
          <div class="description">
            <ul class="props">
              <li class="prop">
                Публичная страница клиники
              </li>
              <li class="prop">
                Панель администрирования клиники
              </li>
              <li class="prop">
                Личные кабинеты сотрудников
              </li>
              <li class="prop">
                Техническая поддержка 24/7
              </li>
            </ul>
          </div>
        </div>
        <div class="actions">
          <button class="add-button">Добавить</button>
        </div>
      </div>
      <div class="module">
        <div class="icon">
          <OrganizationIcon />
        </div>
        <div class="content">
          <div class="title">Модуль "Видеосвязь"</div>
          <div class="description">
            <ul class="props">
              <li class="prop">
                Создание бесед в видеочат-комнате
              </li>
              <li class="prop">
                Добавление в существующую беседу
              </li>
              <li class="prop">
                Просмотр списка доступных бесед
              </li>
              <li class="prop">
                Отправка текстовых сообщений
              </li>
              <li class="prop">
                Отправка файлов
              </li>
              <li class="prop">
                Видеоконференцсвязь
              </li>
              <li class="prop">
                Просмотр записанного видео по итогам видеоконференцсвязи
              </li>
            </ul>
          </div>
        </div>
        <div class="actions">
          <button class="add-button">Добавить</button>
        </div>
      </div>
      <div class="module">
        <div class="icon">
          <OrganizationIcon />
        </div>
        <div class="content">
          <div class="title">Модуль "Запись на приём"</div>
          <div class="description">
            <ul class="props">
              <li class="prop">
                Формирование перечня доступных сотрудников организации и перечня временных окон, доступных для записи
              </li>
              <li class="prop">
                Формирование электронной очереди
              </li>
              <li class="prop">
                Возможность записать на прием другое лицо
              </li>              
            </ul>
          </div>
        </div>
        <div class="actions">
          <button class="add-button">Добавить</button>
        </div>
      </div>
      <div class="module">
        <div class="icon">
          <OrganizationIcon />
        </div>
        <div class="content">
          <div class="title">Модуль "Чат-бот"</div>
          <div class="description">
            <ul class="props">
              <li class="prop">
                Запись на прием через сайт или мобильное приложение
              </li>
              <li class="prop">
                Ответы на часто задаваемые вопросы
              </li>
              <li class="prop">
                Заявка на обратный звонок
              </li>              
            </ul>
          </div>
        </div>
        <div class="actions">
          <button class="add-button">Добавить</button>
        </div>
      </div>
      <div class="module">
        <div class="icon">
          <OrganizationIcon />
        </div>
        <div class="content">
          <div class="title">Модуль "Конструктор форм"</div>
          <div class="description">
            <ul class="props">
              <li class="prop">
                Создание произвольной формы
              </li>
              <li class="prop">
                Подключение формы к странице посредством компонентов
              </li>
              <li class="prop">
                Поддержка версионности форм
              </li>   
              <li class="prop">
                Сохранение данных формы в базу данных с последующим редактированием
              </li>  
              <li class="prop">
                Выведение сводной таблицы по данным формы конкретной версии
              </li>            
            </ul>
          </div>
        </div>
        <div class="actions">
          <button class="add-button">Добавить</button>
        </div>
      </div>
      <div class="module">
        <div class="icon">
          <OrganizationIcon />
        </div>
        <div class="content">
          <div class="title">Модуль "Рассылка уведомлений"</div>
          <div class="description">
            <ul class="props">
              <li class="prop">
                Уведомление пациентов о событиях через email, SMS и через всплывающие сообщения на сайте
              </li>
              <li class="prop">
                Подписка на каналы рассылки уведомлений
              </li>         
            </ul>
          </div>
        </div>
        <div class="actions">
          <button class="add-button">Добавить</button>
        </div>
      </div>
      <div class="module">
        <div class="icon">
          <OrganizationIcon />
        </div>
        <div class="content">
          <div class="title">Модуль "Регистратура"</div>
          <div class="description">
            <ul class="props">
              <li class="prop">
                Формирование организаций, департаментов, должностей, сотрудников
              </li>
              <li class="prop">
                Формирование нагрузки на должность и сотрудника
              </li>  
              <li class="prop">
                Создание расписания сотрудника на конкретном рабочем месте
              </li>    
              <li class="prop">
                Назначение мероприятий на рабочее место на конкретное временное окно
              </li>     
            </ul>
          </div>
        </div>
        <div class="actions">
          <button class="add-button">Добавить</button>
        </div>
      </div>
      <div class="module">
        <div class="icon">
          <OrganizationIcon />
        </div>
        <div class="content">
          <div class="title">Модуль "Справочники"</div>
          <div class="description">
            <ul class="props">
              <li class="prop">
                Справочник МКБ-10
              </li>
              <li class="prop">
                Справочник ГРЛС
              </li>  
              <li class="prop">
                Создание произвольного справочника 
              </li>    
              <li class="prop">
                Создание формы к справочнику 
              </li>    
              <li class="prop">
                Создание и сохранение версий справочника 
              </li>   
            </ul>
          </div>
        </div>
        <div class="actions">
          <button class="add-button">Добавить</button>
        </div>
      </div>
      <div class="module">
        <div class="icon">
          <OrganizationIcon />
        </div>
        <div class="content">
          <div class="title">Модуль "Прием пациента"</div>
          <div class="description">
            <ul class="props">
              <li class="prop">
                Просмотр электронной амбулаторной карты пациента (форма 025/у)
              </li>
              <li class="prop">
                Формирование случаев обращений, посещений и других услуг
              </li>  
              <li class="prop">
                Формирование рецептов и врачебных заключений
              </li>    
              <li class="prop">
                Формирование направлений на анализы и госпитализацию
              </li>     
            </ul>
          </div>
        </div>
        <div class="actions">
          <button class="add-button">Добавить</button>
        </div>
      </div>
      <div class="module">
        <div class="icon">
          <ConsultingIcon />
        </div>
        <div class="content">
          <div class="title">Модуль "Online-консультация"</div>
          <div class="description">
            <ul class="props">
              <li class="prop">
                Подача заявки на консультацию через направление
              </li>
              <li class="prop">
                Проведение телемедицинской консультации посредством видеосвязи
              </li>
              <li class="prop">
                Электронная подпись медицинских документов
              </li>
              <li class="prop">
                Создание заключения по итогам консультации
              </li>
              <li class="prop">
                Поддержка форматов «пациент-врач», «врач-врач», «врач-консилиум»
              </li>
              <li class="prop">
                Сохранение данных телемедицинской консультации в амбулаторных картах 
              </li>
            </ul>
          </div>
        </div>
        <div class="actions">
          <button class="add-button">Добавить</button>
        </div>
      </div>
      <div class="module">
        <div class="icon">
          <SmarthouseIcon />
        </div>
        <div class="content">
          <div class="title">Модуль "Касса"</div>
          <div class="description">
            <ul class="props">
              <li class="prop">
                Формирование перечня услуг организаций
              </li>
              <li class="prop">
                Формирование гибкой системы тарифов
              </li>
              <li class="prop">
                Использование внешних справочников для формирования услуг
              </li>
              <li class="prop">
                Учет оказанных услуг
              </li>
              <li class="prop">
                Оплата услуг через платежную систему
              </li>
            </ul>
          </div>
        </div>
        <div class="actions">
          <button class="add-button">Добавить</button>
        </div>
      </div>
      <div class="module">
        <div class="icon">
          <OrganizationIcon />
        </div>
        <div class="content">
          <div class="title">Модуль "Выгрузка счетов на оплату ТФОМС"</div>
          <div class="description">
            <ul class="props">
              <li class="prop">
                Проверка страховой принадлежности в реестре застрахованных граждан
              </li>
              <li class="prop">
                Формирование реестра счетов на оплату
              </li>
              <li class="prop">
                Формирование файла реестра установленного образца для отправки в ТФОМС
              </li>
              <li class="prop">
                Чтение пришедшего файла ответа и возможность внесения поступивших правок
              </li>
              <li class="prop">
                Хранения и версионирование формируемых счетов
              </li>
            </ul>
          </div>
        </div>
        <div class="actions">
          <button class="add-button">Добавить</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import OrganizationIcon from '@app/images/icons/modules/organization.svg?inline';
import ConsultingIcon from '@app/images/icons/modules/consulting.svg?inline';
import SmarthouseIcon from '@app/images/icons/modules/smart-house.svg?inline';

export default {
  components: {
    OrganizationIcon,
    ConsultingIcon,
    SmarthouseIcon
  },
  created() {
    // console.log(svg);
  }
};
</script>

<style lang="scss" scoped>
h2 {
  margin-bottom: 2rem;
  color: #737373;
  font-size: 1.5rem;
}
.module {
  background-color: #fff;
  padding: 2rem;
  border: 1px solid #ecedf0;
  border-radius: 0.25rem;
  box-shadow: 0 0 8px 5px rgba(0, 0, 0, 0.025);
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}
.icon {
  padding: 1rem;
  width: 90px;
  height: 90px;
  flex: 0 0 90px;
  border: 3px solid #a6ddf4;
  overflow: hidden;
  border-radius: 50%;
}
.icon svg {
  width: 50px;
  height: 50px;
}
.actions {
  display: flex;
  margin-left: auto;
  align-self: flex-start;
}
.actions .add-button {
  background-color: #fff;
  color: #a6ddf4;
  font-weight: 600;
  border: 2px solid #b6dcf3;
  padding: 0.5rem 1rem;
  border-radius: 44px;
  transition: background-color 200ms, color 200ms;
  outline: none;
}
.actions .add-button:hover {
  background-color: #a6ddf4;
  color: #fff;
}
.content {
  margin-left: 2rem;
}
.content .title {
  margin-bottom: 1rem;
  font-size: 1.5rem;
}
.props {
  list-style: none;
  padding: 0;
}
.props .prop {
  color: #a3aab8;
  font-weight: 300;
  margin-bottom: 3px;
}
.props .prop:last-child {
  margin-bottom: 0;
}
</style>
